import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useOverlay } from '../context/OverlayContext';

const ResetPasswordPage = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [token, setToken] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const { showOverlay } = useOverlay();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const resetToken = queryParams.get('token');
    if (resetToken) {
      setToken(resetToken);
    } else {
      showOverlay('No reset token found in the URL.', 'error');
    }
  }, [location, showOverlay]);

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!token) {
      showOverlay('No reset token available.', 'error');
      return;
    }

    if (password !== confirmPassword) {
      showOverlay('Passwords do not match.', 'error');
      return;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,}$/;
    if (!passwordRegex.test(password)) {
      showOverlay('Password must be at least 6 characters long, contain at least one uppercase letter, one lowercase letter, and one number.', 'error');
      return;
    }

    try {
      const response = await fetch('https://best3intennis.com/best3intennis-api/api/reset_password.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await response.json();
      if (response.ok) {
        showOverlay('Password reset successful! You can now log in with your new password.', 'success', () => navigate('/login'));
      } else {
        showOverlay(data.message || 'An unexpected error occurred during password reset.', 'error');
      }
    } catch (error) {
      console.error('Password reset error:', error);
      showOverlay('A network error occurred during password reset.', 'error');
    }
  };

  return (
    <div className="bg-gradient-to-br from-green-100 to-yellow-100 min-h-screen flex items-center justify-center p-4">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center text-green-800">Reset Password</h2>
        {token ? (
          <form onSubmit={handleResetPassword} className="space-y-4">
            <div>
              <label htmlFor="newPassword" className="block text-gray-700 text-sm font-bold mb-2">New Password<span className="text-red-500">*</span></label>
              <input
                type="password"
                id="newPassword"
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-green-500"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {password && !password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,}$/) && (
                <p className="text-red-500 text-xs italic mt-1">
                  Password must be at least 6 characters, include uppercase, lowercase, and a number.
                </p>
              )}
            </div>
            <div>
              <label htmlFor="confirmNewPassword" className="block text-gray-700 text-sm font-bold mb-2">Confirm New Password<span className="text-red-500">*</span></label>
              <input
                type="password"
                id="confirmNewPassword"
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-green-500"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              {confirmPassword && password !== confirmPassword && (
                <p className="text-red-500 text-xs italic mt-1">Passwords do not match.</p>
              )}
              {confirmPassword && password === confirmPassword && (
                <span className="text-green-500 text-xs italic mt-1">Passwords match!</span>
              )}
            </div>
            <button type="submit" className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-6 rounded-md transition duration-300 w-full">
              Reset Password
            </button>
          </form>
        ) : (
          <p className="text-center text-gray-600 p-4 bg-gray-50 rounded-md">Please use the link from your email to reset your password.</p>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;


